import { useMessage } from '@tmapy/intl';
import React, { createContext, useEffect } from 'react';
import { defineMessages } from 'react-intl.macro';
import { APP_TYPE, AppContext, appContextValues } from './constants';

export const appContext = createContext<AppContext>(appContextValues[APP_TYPE.PREJIMKA]);

const Provider = appContext.Provider;

const titleMessages = defineMessages<APP_TYPE>({
  [APP_TYPE.PREJIMKA]: {
    id: 'prejimka.window.title',
    defaultMessage: 'Přejímka',
  },
  [APP_TYPE.MANAGER]: {
    id: 'manager.window.title',
    defaultMessage: 'Manažer',
  },
  [APP_TYPE.VYDEJ]: {
    id: 'vydej.window.title',
    defaultMessage: 'Výdej',
  },
});

interface IAppContextProviderProps {
  appType: APP_TYPE;
  children: React.ReactNode;
}

export const AppContextProvider: React.FC<IAppContextProviderProps> = ({ appType, children }) => {
  const formatMessage = useMessage();
  useEffect(() => {
    window.document.title = formatMessage(titleMessages[appType]);
  }, [appType, formatMessage]);
  return <Provider value={appContextValues[appType]}>{children}</Provider>;
};
